import request from './index';

// 添加任务
export const addTask = (params) => {
    return request.post('/h5add', params);
};
// 上传图片
export const uploadImg = (params) => {
    return request.post('/upload', params);
};

// 提交两题图片
export const addFitter = (params) => {
    return request.post('/h5tjimg', params);
};

// 获取量体详情
export const getInfo = (params) => {
    return request.post('/h5info', params);
};

// 提交部件参数
export const postParts = (params) => {
    return request.post('/h5tjparams', params);
};

// 获取2d衣服部件
export const getPartsImgs = (params) => {
    return request.post('/h5get2d', params);
};

// 获取小程序二维码
export const h5qrcode = (params) => {
    return request.post('/h5qrcode', params);
};